import React from 'react';
import AdminPanel from '../../components/AdminPanel';

const AdminPage = () => <AdminPanel />;

export default AdminPage;
